<template>
  <div id="Summary" class="Summary">
    <div class="list-item">
      <div class="lable-item">
        <div class="lable">下单时间 </div>
        <span class="content">{{ data.creatorTimeCn }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">下单人</div>
        <span class="content">{{ data.creatorName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">货好时间</div>
        <span class="content">{{ data.goodsReadyTimeCn }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">货物类型</div>
        <span class="content">{{ data.cargoTypeNames }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">品名</div>
        <span class="content">{{ data.productName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">申报价值</div>
        <span class="content">USD{{ data.totalValue }}</span>
      </div>
    </div>
    <div class="list-item">
      <div class="lable-item">
        <div class="lable">报关服务</div>
        <span class="content">{{ data.customsService }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">保险服务</div>
        <span class="content">{{ data.buyInsurance ==0?'否':'是' }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">下单备注</div>
        <span class="content">{{ data.remark }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  UpdateGoodsReadyTime,
  GetFbaOrderDetail
} from '@/api/order.js'
import {
  GetDictionaryData
} from '@/api/base.js'
export default {
  name: 'Summary',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      isEditTime: false,
      goodsReadyTime: undefined,
      modeCodeOptions: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.getModeCodesOptions()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    getModeCodesOptions() {
      GetDictionaryData('fbamode').then(res => {
        if (res.code === 200) {
          this.modeCodeOptions = res.data
        }
      })
    },
    eidtTimeCancel() {
      this.isEditTime = false
    },
    eidtTime() {
      this.isEditTime = true
    },
    saveTime(val) {
      UpdateGoodsReadyTime({
        orderNo: this.data.orderNo,
        goodsReadyTime: val
      }).then(res => {
        if (res.code === 200) {
          this.isEditTime = false
          this.initOrder(this.data.orderNo)
        }
      })
    },
    init(data) {
      this.data = data
      this.$forceUpdate()
      this.goodsReadyTime = new Date(this.data.goodsReadyTime)
    },
    initOrder(orderNo) {
      GetFbaOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.Summary {
		display: flex;
		flex-wrap: wrap;
		width: auto;
    justify-content: space-between;

		.list-item {
			width: 530px;
			background: #F5F6F9;
			border-radius: 8px;
			padding: 8px 20px;
			text-align: left;

			.title {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				height: 32px;
				line-height: 32px;
			}

			.lable-item {
				display: flex;
				height: 40px;
				align-items: center;

				.lable {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #666666;
					width: 27%;
				}

				.content {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
				}

				.content-cancel {
					color: #E95506;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>
